/**
 * Previously rendered notification, language, and theme in the top-right header.
 * Those controls now live in the User Profile dropdown in the left sidebar.
 * This component is kept for backwards compatibility (call sites unchanged) but renders nothing.
 */
export function DashboardHeaderControls() {
  return null;
}
